const common = {
    language: {
        bg: 'BG',
        en: 'EN',
        switchLabel: 'Change language',
    },
    actions: {
        close: 'Close',
    },
    eventDate: {
        day: '26',
        month: 'September',
    },
    nav: {
        admin: 'Admin',
        conditions: 'Participation Terms',
        courses: 'Course Information',
        home: 'Home',
        participants: 'Participants',
        payment: 'Payment',
        register: 'Register',
        results: 'Results',
        toggleMenu: 'Open menu',
        records: 'Records',
    },
};

export default common;
